module.exports = __webpack_public_path__ + "static/media/camera.e5759f1f.svg";